import type { OfflineAccessState } from "./state";

export class OfflineAccessInvalidError extends Error {
  constructor(
    readonly canonicalUrl: string,
    readonly reason: OfflineAccessState["reason"],
  ) {
    super(`Offline access is invalid: ${reason}`);
    this.name = "OfflineAccessInvalidError";
  }
}

export const isOfflineAccessInvalidError = (
  error: unknown,
): error is OfflineAccessInvalidError =>
  error instanceof OfflineAccessInvalidError;
